<template>
    <div>
        Forbidden
    </div>
</template>

<script>
export default {
    name: 'PadmawebForbiddenView',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>